import { useRef, useEffect, useState } from 'react';
import { useOnboarding } from '../../../context/OnboardingContext';
import { stripeGlobal, logPurchaseCompletedSuccess } from './StripeHelper';
import { getPlanPrice } from '../../../config/plans';
import { trackPurchaseStarted, trackInitiateCheckout, trackPurchaseFailed } from '../../../services/analytics';
import { createStripeSubscription } from '../../../services/api';
import AccordionPanel from './shared/AccordionPanel';

const StripeCard = ({ isExpanded, onSelect }) => {

    const { userID, selectedPlan, onboardingId, formData, globalAnswers, goToNextScreen, urlParams } = useOnboarding();
    const [isStripeLoading, setIsStripeLoading] = useState(true);
    const [isProcessing, setIsProcessing] = useState(false);

    const stripeElementsRef = useRef(null);

    useEffect(() => {

        console.log("stripe card: ", stripeGlobal)

        setIsStripeLoading(true);

        console.log("selectedPlan changed", selectedPlan);

        const price = getPlanPrice(selectedPlan?.id);

        const elementsConfig = {
            amount: price,
            currency: "usd",
            mode: "subscription",
            paymentMethodTypes: ["card"],
            paymentMethodCreation: "manual",
            appearance: {
                variables: { colorText: '#000000', colorBackground: '#ffffff1f', colorPrimary: '#000000' },
                rules: {
                    ".Input": {
                        borderColor: "#0000001a"
                    }
                }
            }
        }

        console.log("get stripe elements", stripeGlobal)

        stripeElementsRef.current = stripeGlobal.elements(
            elementsConfig
        );

        const paymentElement = stripeElementsRef.current.create('payment', {
            "layout": "tabs",
            "wallets": {
                "applePay": "never",
                "googlePay": "never"
            },
            "terms": {
                "card": "never"
            }
        })

        // Скрываем loader когда Stripe элемент готов
        paymentElement.on('ready', () => {
            console.log('Stripe Payment Element is ready');
            setIsStripeLoading(false);
        });

        paymentElement.mount('#card-element');


    }, [selectedPlan]);

    const handleContinue = async () => {

        setIsProcessing(true);


        try {
            trackInitiateCheckout(formData.get('email') ?? "unknown");
        } catch (error) {
            console.error('Error logging initiate checkout:', error);
        }

        try {
            trackPurchaseStarted({
                type: 'stripeCard',
                onboardingId,
                priceID: selectedPlan?.priceID,
                discountID: selectedPlan?.discountID,
            });
        } catch (error) {
            console.error('Error tracking purchase started:', error);
        }

        try {
            console.log('handleContinue');

            const { error: submitError } = await stripeElementsRef.current.submit();
            if (submitError) {
                console.log(submitError);
                return;
            }

            let sub = await doCreateSubscription();

            if (!sub.ok) { console.log('Server error'); return; }
            const { clientSecret, subscriptionId, customerId, status } = await sub.json();

            console.log('clientSecret', clientSecret);
            console.log('subscriptionId', subscriptionId);
            console.log('customerId', customerId);
            console.log('status', status);

            localStorage.setItem('customerID', customerId);
            localStorage.setItem('paymentProvider', 'stripe');

            // 4) подтверждаем первый платеж инвойса подписки
            const { error, paymentIntent } = await stripeGlobal.confirmPayment({
                elements: stripeElementsRef.current,
                clientSecret,
                // без редиректа если 3DS не нужен; если нужен — Stripe сам покажет модалку
                redirect: 'if_required',
            });

            if (error) {

                let errorMessage = error.message ?? null;

                if (errorMessage) {
                    alert(errorMessage + " Please try another card.");
                }

                try {
                    trackPurchaseFailed({
                        onboardingId,
                        paymentProvider: 'stripe',
                        data: {
                            errorMessage,
                        }
                    });
                } catch (error) {
                    console.error('Error tracking purchase started:', error);
                }
        
                console.log('card error: ', error);
                return;
            }

            if (paymentIntent?.status === 'succeeded' || paymentIntent?.status === 'processing') {
                console.log('paymentIntent succeeded 2', paymentIntent);

                const price = getPlanPrice(selectedPlan?.id);
                const email = formData.get('email') ?? "unknown";

                logPurchaseCompletedSuccess(onboardingId, selectedPlan?.priceID, selectedPlan?.discountID, price, urlParams, email);

                goToNextScreen();

            } else {
                console.log('card error: ', paymentIntent, error);
            }
        } finally {
            setIsProcessing(false);
        }
    }

    const doCreateSubscription = async () => {
        let email = formData.get('email') ?? null;
        if (!email) {
            email = prompt("Please enter your email");
            if (!email) return;
        }

        return createStripeSubscription({
            userID,
            email,
            priceID: selectedPlan?.priceID,
            discountID: selectedPlan?.discountID,
            onboardingID: onboardingId,
            goal: globalAnswers.get('goal')?.value || "unknown",
            voice: globalAnswers.get('voice')?.value || "unknown",
            queryParams: urlParams || {}
        });
    }

    return (
        <section
            className="item"
            data-state={isExpanded ? 'expanded' : 'collapsed'}
            onClick={onSelect}
        >
            <button type="button" className="trigger" aria-expanded={isExpanded}>
                <div className="radio-circle"></div>
                <div className="payment-icons">
                    <div className="image-wrap svelte-grrljh">
                        <img
                            className="payment-method-icon svelte-171041c"
                            src="/assets/images/cards.webp"
                            alt="visa, mastercard"
                            style={{ maxHeight: 'calc(30 * var(--px))' }}
                        />
                    </div>
                </div>
            </button>
            <AccordionPanel expanded={isExpanded}>
                <div className="panel" role="region">
                    <div style={{ position: 'relative', minHeight: '100px' }}>
                        <div id="card-element"></div>
                    </div>
                    <div data-testid="stripe-card-checkout" className="container svelte-ykx1g">
                        <button onClick={handleContinue} className="svelte-1wws8ka" type="button" disabled={isProcessing}>
                            <div className="svelte-lss1u3">
                                {isProcessing || isStripeLoading ? (
                                    <div style={{
                                        width: '20px',
                                        height: '20px',
                                        border: '3px solid rgba(255, 255, 255, 0.3)',
                                        borderTop: '3px solid #ffffff',
                                        borderRadius: '50%',
                                        animation: 'spin 0.8s linear infinite',
                                        margin: '0 auto'
                                    }}></div>
                                ) : (
                                    'Continue'
                                )}
                            </div>
                        </button>
                    </div>
                    <div className="footer svelte-p3ln32">
                        <span className="svelte-kfp6vj">Your payment information is secure with SSL/TLS encryption</span>
                    </div>
                </div>
            </AccordionPanel>
        </section>
    );
};

export default StripeCard;

